<template>
  <div>
    <head>
      <link rel="stylesheet" :href="css">
    </head>
    <div class="black-overlay"></div>
    <div class="modal modal--postfreegame" id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close" @click="goToHomePage"><i class="icon-close"></i></button>
        <div class="game_bg pre_post">
        <div class="game_box" v-if="addOnBonusGameData.success">
          <div class="title">{{ getTranslations.home_addongame_puzzle_great }}</div>
          <div class="subtitle">{{ getTranslations.home_addongame_puzzle_completed }}</div>
          <img :src="'static/mini_games/puzzle_game/assets/'+img+'.png'" alt="game background">
          <p class="won_lost">{{ getTranslations.home_addongame_puzzle_you_earned }}<br> <span>{{ addOnBonusGameData.prizeType }}</span> {{ getTranslations.home_addongame_puzzle_points }}</p>
        </div>
        <div class="game_box" v-else>
          <div class="title">{{ getTranslations.home_addongame_puzzle_oh_no }}</div>
          <div class="subtitle">{{ getTranslations.home_addongame_puzzle_unfortunately_not }}</div>
          <img src="static/mini_games/puzzle_game/assets/bg_puzzle.png" alt="game background">
          <p class="won_lost">{{ getTranslations.home_addongame_puzzle_lucky_next_time }}<br> {{ getTranslations.home_addongame_puzzle_give_up }}</p>
        </div>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import Modal from '../../modals/shared/GenericModal';

export default {
  name: 'result-of-add-on-game',
  components: { Modal },
  data() {
    return {
      css: '',
      img: '',
    };
  },
  created() {
    this.css = localStorage.getItem('locale') === ('AR' || 'KU') ?
      `../../../../../static/mini_games/puzzle_game/${this.puzzleGameCss}_AR.css` :
      `../../../../../static/mini_games/puzzle_game/${this.puzzleGameCss}.css`;
    // if (!this.addOnGameData.gameId) this.$router.push('/home');
    // eslint-disable-next-line
    this.img = this.puzzleGameCss === 'puzzle' ? 'bg_puzzle' : 'bg_puzzle_ramadan';
    const payload = {
      successful: this.addOnBonusGameData.success,
      achievementName: this.addOnBonusGameData.achievementName,
      prize: this.addOnBonusGameData.prizeType,
      gameType: 'PUZZLE',
    };
    this.updateDBonusAddOnGames(payload);
  },
  beforeDestroy() {
    this.clearPuzzleGame();
    this.resetBonusAddOnGameData();
    this.setActiveAddOnMiniGame(false);
    // eslint-disable-next-line
    $('.header-main').show();
  },
  methods: {
    ...mapActions('profile', [
      'updateDBonusAddOnGames',
    ]),
    ...mapMutations('game', [
      'resetBonusAddOnGameData',
    ]),
    ...mapMutations('profile', [
      'clearPuzzleGame',
    ]),
    ...mapMutations('common', [
      'setActiveAddOnMiniGame',
    ]),
    goToHomePage() {
      this.$router.push('/home');
    },
  },
  computed: {
    ...mapState('common', [
      'puzzleGameCss',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('game', [
      'addOnBonusGameData',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/game/addongamepuzzle/ResultOfAddOnGame.vue